import type { SnackBlocks, SnackList } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { SnackBlocksZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "uuid", "companyID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DesignSnackBlocksFormModel = AutoGeneratorForFormModel<
	SnackBlocksZodSchemaType, //
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;

export type ServerModel = SnackBlocks & { companyID: string } & { snackList: SnackList };
